import React from "react";

const Layouts = () => {
  return <h1>Layouts Page</h1>;
};

export default Layouts;
